module.exports = __webpack_public_path__ + "static/media/select-down-arrow.4a9d1947.svg";